export default "__VITE_ASSET__CvTvEm7m__ 500w";